import type { BuyerVisibility, WorkspaceState, BuyerShareState } from '../types/report';

export const balancedVisibility: BuyerVisibility = {
  issuesList: true,
  severity: true,
  rationale: true,
  costEstimates: false,
  agentNotes: false,
  photos: true,
  specialists: true,
};

export const fullVisibility: BuyerVisibility = {
  issuesList: true,
  severity: true,
  rationale: true,
  costEstimates: true,
  agentNotes: true,
  photos: true,
  specialists: true,
};

export const minimalVisibility: BuyerVisibility = {
  issuesList: true,
  severity: true,
  rationale: false,
  costEstimates: false,
  agentNotes: false,
  photos: false,
  specialists: false,
};

export const createDefaultWorkspaceState = (recommendedIssueNumbers: number[] = []): WorkspaceState => ({
  negotiation_builder: {
    selectedIssueNumbers: recommendedIssueNumbers,
    priorityOverrides: {},
    costOverrides: {},
    justificationText: {},
    privateAgentNotes: {},
    requestMode: 'repairs',
  },
  client_prep: {
    visibilityPreset: 'balanced',
    visibility: balancedVisibility,
    customBuyerMessage: '',
    talkingPoints: [],
    openingStatement: '',
    closingScript: '',
  },
  generated_documents: [],
});

export const defaultBuyerShareState: BuyerShareState = {
  status: 'draft',
  buyerUrl: null,
  expiresAt: null,
  revokedAt: null,
  viewedAt: null,
  visibleIssueNumbers: [],
  lastGeneratedPayloadVersion: 0,
};
